import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GetExtensionDetail_extension_extensionExternalForward } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-extension-external-forward-detail-left-column',
    styleUrls: [
        './extension-external-forward-detail-left-column.component.scss',
        '../extension-detail-view.component.scss',
    ],
    templateUrl: './extension-external-forward-detail-left-column.component.html',
    standalone: false
})
export class ExtensionExternalForwardDetailLeftColumnComponent {
   @Input() extensionExternalForward: GetExtensionDetail_extension_extensionExternalForward | null;
}
